import { Record } from 'immutable';

const ConnectionRecord = Record({
  id: null,
  sessionId: null,
  object: null,
  createdAt: null,
  data: null,
});

export default class Connection extends ConnectionRecord {}
